import script from "./pay-front-money.vue?vue&type=script&lang=ts&setup=true"
export * from "./pay-front-money.vue?vue&type=script&lang=ts&setup=true"

import "./pay-front-money.vue?vue&type=style&index=0&id=5401be61&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5401be61"]])

export default __exports__